export default __webpack_public_path__ + "static/media/individualservo.de016928.svg";